import { z } from "zod";

export const OPPORTUNITY_TIMING_SEGMENT_TYPE = {
  AGENT_WORKING: "AGENT_WORKING",
  WAITING_APPROVAL: "WAITING_APPROVAL",
} as const;

export const OPPORTUNITY_TIMING_SEGMENT_TYPE_VALUES = Object.values(
  OPPORTUNITY_TIMING_SEGMENT_TYPE,
) as [string, ...string[]];

export type OpportunityTimingSegmentType =
  (typeof OPPORTUNITY_TIMING_SEGMENT_TYPE)[keyof typeof OPPORTUNITY_TIMING_SEGMENT_TYPE];

export const OPPORTUNITY_TIMING_SEGMENT_LABELS: Record<
  OpportunityTimingSegmentType,
  string
> = {
  [OPPORTUNITY_TIMING_SEGMENT_TYPE.AGENT_WORKING]: "Agent Working",
  [OPPORTUNITY_TIMING_SEGMENT_TYPE.WAITING_APPROVAL]: "Waiting for Approval",
};

export const OpportunityTimingSegmentSchema = z.object({
  type: z.enum(OPPORTUNITY_TIMING_SEGMENT_TYPE_VALUES),
  durationSeconds: z.number(),
  label: z.string(),
});
export type OpportunityTimingSegment = z.infer<
  typeof OpportunityTimingSegmentSchema
>;

export const OpportunityTimingResponseSchema = z.object({
  timeToQuoteBusinessSeconds: z.number().nullable(),
  timeToCloseBusinessSeconds: z.number().nullable(),
  agentWorkingSeconds: z.number(),
  waitingApprovalSeconds: z.number(),
  segments: z.array(OpportunityTimingSegmentSchema),
});
export type OpportunityTimingResponse = z.infer<
  typeof OpportunityTimingResponseSchema
>;
